import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Experience from "./pages/Experience";
import Projects from "./pages/Projects";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";



function App() {
  return (
    <div className="App">
      <Router>
      <Navbar/>
        <Routes>
          
          <Route>
            <Route path="/" element={<Home />} />
            <Route path="experience" element={<Experience />} />
            <Route path="projects" element={<Projects />} />
          </Route>
        </Routes>
        <Footer/>
      </Router>
    </div>
  );
}

export default App;
